import type { RouteRecordRaw } from 'vue-router'

export const adminHelpCenterRoutes: RouteRecordRaw[] = [
  {
    path: 'help-center',
    name: 'admin.helpcenter',
    component: () => import('../../views/admin/help-center/HelpCenterDashboardView.vue'),
    meta: {
      title: 'Help Center',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'help-center/articles',
    name: 'admin.helpcenter.articles',
    component: () => import('../../views/admin/help-center/HelpCenterArticlesView.vue'),
    meta: {
      title: 'Help Center - Articles',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'help-center/articles/new',
    name: 'admin.helpcenter.articles.new',
    component: () => import('../../views/admin/help-center/HelpCenterCreateChooserView.vue'),
    meta: {
      title: 'Help Center - New Article',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'help-center/articles/new/template',
    name: 'admin.helpcenter.articles.template',
    component: () => import('../../views/admin/help-center/HelpCenterTemplateBuilderView.vue'),
    meta: {
      title: 'Help Center - Template Builder',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'help-center/articles/new/editor',
    name: 'admin.helpcenter.articles.new.editor',
    component: () => import('../../views/admin/help-center/HelpCenterArticleEditView.vue'),
    meta: {
      title: 'Help Center - Write Article',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'help-center/articles/:id/edit',
    name: 'admin.helpcenter.articles.edit',
    component: () => import('../../views/admin/help-center/HelpCenterArticleEditView.vue'),
    meta: {
      title: 'Help Center - Edit Article',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'help-center/categories',
    name: 'admin.helpcenter.categories',
    component: () => import('../../views/admin/help-center/HelpCenterCategoriesView.vue'),
    meta: {
      title: 'Help Center - Categories',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'help-center/media',
    name: 'admin.helpcenter.media',
    component: () => import('../../views/admin/help-center/HelpCenterMediaView.vue'),
    meta: {
      title: 'Help Center - Media Library',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'help-center/analytics',
    name: 'admin.helpcenter.analytics',
    component: () => import('../../views/admin/help-center/HelpCenterAnalyticsView.vue'),
    meta: {
      title: 'Help Center - Analytics',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'help-center/portal',
    name: 'admin.helpcenter.portal',
    component: () => import('../../views/admin/help-center/HelpCenterPortalPreviewView.vue'),
    meta: {
      title: 'Help Center - Portal Preview',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'help-center/portal/category/:id',
    name: 'admin.helpcenter.portal.category',
    component: () => import('../../views/admin/help-center/HelpCenterPortalCategoryView.vue'),
    meta: {
      title: 'Help Center - Category Preview',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'help-center/portal/article/:id',
    name: 'admin.helpcenter.portal.article',
    component: () => import('../../views/admin/help-center/HelpCenterPortalArticleView.vue'),
    meta: {
      title: 'Help Center - Article Preview',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
]
